/**
 * Returns the given date in a formatted string.
 * @param params
 * @returns
 */
export function useFormattedDateObj(date?: Date) {
  return date ? new Date(date) : new Date();
}
